import { createSlice } from "@reduxjs/toolkit";
import { IDepartmentResourceSlice } from "../../../models/master/departmentResources";


const initialDepartmentResourceState: IDepartmentResourceSlice = {
  departmentResources:undefined,
  departmentResource:undefined
};

const departmentResourceSlice = createSlice({
  name: "departmentResource",
  initialState: initialDepartmentResourceState,
  reducers: {
    setDepartmentResources: (state, action: { payload: any }) => {
      state.departmentResources = action.payload;
    },
    setDepartmentResource: (state, action: { payload: any }) => {
      state.departmentResource = action.payload;
    },
    
  },
});

export const { setDepartmentResources, setDepartmentResource } =
departmentResourceSlice.actions;

const departmentResourceReducer = departmentResourceSlice.reducer;

export type departmentResourceState = ReturnType<typeof departmentResourceReducer>;

export default departmentResourceReducer;
